import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { SecurityMasterComponent } from '@irb/irb-models/security-master/security-master.component';
import { IrbModelsEvents } from '@irb-common/events';
import { IDropdownItem } from '@irb/irb-common/models/dropdown.model';
import { DropdownFilterRendererComponent } from "@irb-common/components/grid/renderers/dropdown-filter.cell.component";
import { AppService } from '@irb/app.service';
import { SecurityMasterAssetCategoryService } from '@irb/irb-models/security-master/security-master.asset-category.service';
import { DropdownSearchMultipleRendererComponent } from '@irb-common/components/grid/renderers/dropdown-search-multiple.cell.component';
import { MorningstarService } from './morningstar.service';
import { SacSecurityTypeService } from './sac-security-type.service';
@Injectable({
    providedIn: 'root'
})
export class SecurityMasterGridLayoutService implements GridLayoutService<SecurityMasterComponent> {
    constructor(private as: AppService, private smac: SecurityMasterAssetCategoryService, private mss: MorningstarService, private ssts: SacSecurityTypeService) {}

    getFrameworkComponents() {
        return {
            DropdownFilterRendererComponent: DropdownFilterRendererComponent,
            DropdownSearchMultipleRendererComponent: DropdownSearchMultipleRendererComponent
        };
    }

    getColumnDefs(parent: SecurityMasterComponent) {
        let cols = [{
                headerName: '',
                suppressColumnsToolPanel: true,
                children: [{
                    headerName: 'Select All',
                    colId:'selectAll',
                    headerComponent: 'customHeader',
                    cellRenderer : 'customHeader',
                    cellRendererParams: {parentObject: parent, type: 'rowCheckBox' },
                    suppressColumnsToolPanel: true,
                    suppressFiltersToolPanel:true,
                    suppressSizeToFit: true,
                    toolPanelClass: 'toolpanel-header-checkbox-hide',
                    headerComponentParams: {parentObject: parent, type: 'headerCheckBox' },
                    floatingFilterComponent: 'customHeader',
                    floatingFilterComponentParams: { parentObject: parent, type: 'NoClearAllBtn' },
                    suppressFloatingFilterButton: true,
                    pinned: 'left',
                    suppressMovable: true,
                    lockPosition: true,
                    lockVisible: true,
                    sortable: false,
                    filter: true,
                    resizable: true,
                    minWidth: 24,
                    width: 24,
                    maxWidth:24,
                    cellStyle: {'padding' : '5px 3px 0 2px'},
                    headerClass: 'customHeaderClassSelectAll',
                    cellClass: 'selectAllCheckBoxRecord'
                }]
            },{
                headerName: 'Security',
                children: [
                    {
                    headerName: 'Symbol',
                    colId:'securitySymbol',
                    field: 'securitySymbol',
                    sort: "asc",
                    lockPosition: true,
                    lockVisible: true,
                    minWidth: 80,
                    maxWidth: 150,
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        buttons:['reset', 'apply'],
                        values: (params: any) => {
                            params.success(parent.securitySymbolList);
                        },
                        newRowsAction: 'keep',
                        suppressSorting: true,
                        cellHeight: 30,
                        refreshValuesOnOpen: true,
                        closeOnApply: true
                    },
                    cellRenderer : 'cellRendererFormatter'  ,
                    cellRendererParams: {
                        columnToolTipInfo: this.cashSecurity(),
                        link: (params: any) => {
                            return (params.value != null && params.value.length > 0);
                        },
                        onClick: (function (data: any) {
                            this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_SECURITY, { data: data });
                        }).bind(this),
                        calltoactionTemplateFunc: parent.ENABLE_FLYOUT ? (params: any) => parent.getSymbolTemplate(params) : undefined
                    }
                    },               
                {
                    headerName: 'Description',
                    colId:'securityDescription',
                    field: 'securityDescription',
                    minWidth: 140,
                    filter: 'agTextColumnFilter',
                    suppressFloatingFilterButton: true,
                    cellRenderer : 'cellRendererFormatter'
                },{
                    headerName: parent.ENABLE_AS_SECTYPE ? 'Trade Type' : 'Type',
                    colId:'securityType',
                    field: 'securityType',
                    cellRendererSelector: this.formatSecurityTypeSelector,
                    maxWidth: 150,
                    minWidth: 80,
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        buttons:['reset', 'apply'],
                        values: (params: any) => {
                        params.success(parent.securityTypeList);
                        },
                        newRowsAction: 'keep',
                        suppressSorting: true,
                        cellHeight: 30,
                        refreshValuesOnOpen: true,
                        closeOnApply: true
                    }
                },{
                    headerName: 'In # Sec Models',
                    colId:'securityModels',
                    field: 'securityModels',
                    cellRenderer : 'cellRendererFormatter',
                    maxWidth: 165,
                    minWidth: 80,
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        buttons:['reset', 'apply'],
                        values: (params: any) => {
                            params.success(parent.securityModels);
                        },                    
                        newRowsAction: 'keep',
                        suppressSorting: true,
                        cellHeight: 30,
                        refreshValuesOnOpen: true,
                        closeOnApply: true
                        },
                    cellRendererParams: (params: any) => {
                        return {
                        link: () => params.data && params.data.securityModels > 0,
                        onClick: ((data: any) => {
                            parent.showModelDetails(data);
                        }).bind(this)
                        };
                    }
                },{
                    headerName: parent.customCategory,
                    headerValueGetter: () => parent.customCategory,
                    field: 'customCategoryName',
                    suppressFiltersToolPanel: true,
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        buttons: ['reset', 'apply'],
                        newRowsAction: 'keep',
                        suppressSorting: true,
                        cellHeight: 30,
                        refreshValuesOnOpen: true,
                        closeOnApply: true,
                        values: (params: any) => {
                        params.success(parent.customCategoryList);
                        }
                    },
                    headerComponentParams:{
                        irbColInfo: this.customCategoryColInfo()
                    },
                    minWidth: 80,
                    cellClass:'dropdownFilterCell',
                    cellRenderer:'DropdownFilterRendererComponent',
                    cellRendererParams: (params: any) => {
                        const addNewItemConfig = {
                            button: 'Add new category',
                            type: 'assetCategory',
                            fromComp: 'SecurityMasterComponent',
                            rowIndex: params.rowIndex || params.node.rowIndex
                        };
                        let defaultValueCustCat: any = {name: params.data.customCategoryName, value: params.data.customCategoryName};
                        if (params.data.mStarRecommendedCategoryId && params.data.mStarRecommendedCategoryName === params.data.customCategoryName) {
                            defaultValueCustCat = {
                                name: '*' + params.data.mStarRecommendedCategoryName,
                                value: '*' + params.data.mStarRecommendedCategoryName,
                                class: ['dd-msstar-recommended']
                            }
                        }
                        return {
                            defaultValue: defaultValueCustCat,
                            values: parent.getCustCategoriesDropdownOptions(parent.customCategoryList, params.data),
                            placeholder: 'none',
                            addNewItemConfig: addNewItemConfig,
                            onChange: (params: any, item: IDropdownItem) =>{
                                parent.onCategoryDropdownChanged(params, item);
                            },
                            openNewItemFlow: (dataParam: any) => {
                                dataParam = Object.assign({}, addNewItemConfig, dataParam);
                                parent.openNewItemCategoryFlow(dataParam);
                            }
                        };
                    }
                },{
                    headerName: 'NER',
                    colId:'netExpenseRatio',
                    headerComponentParams:{
                        irbColInfo: this.nerColInfo()
                    },
                    field: 'netExpenseRatio',
                    // cellRenderer : 'cellRendererFormatter',
                    //cellRendererParams: {type: 'currency', displaySymbol: '%',decimalPosition:'2'},
                    cellRendererSelector: (params: any) => {
                        if (params.data) {
                            if (params.data.netExpenseRatio === null || params.data.netExpenseRatio === 0) {
                            return {
                                component: 'cellRendererFormatter',
                                params: { value: 'n/a' },
                                };
                            } else {
                                return{
                                component: 'cellRendererFormatter',
                                params: { value:  params.data.netExpenseRatio + " %"} 
                                } 
                            } 
                        }
                    },
                    maxWidth: 150
                }]
            }] as any;

                cols.push({
                    headerName: 'Schwab Asset Classes',
                    children: [
                        {
                            headerName: "Level 1",
                            field: "acLevel1",
                            minWidth: 80,
                            suppressFiltersToolPanel: true,
                            sortable: false,
                            floatingFilterComponent: 'irbInputFloatingFilterComponent',
                            filter: 'irbAgSearchMultipleColumnFilterComponent',
                            filterParams: (_params: any) => {
                                return {
                                    values: this.smac.getDropdownOptionsForAssetClasses(this.smac.assetClassesLevel1),
                                    enableHiddenSearchResults: false,
                                    enableEmptySearchTerm: true
                                }
                            },    
                            cellClass: 'dropdownSearchMultipleCell',
                            cellRenderer: 'DropdownSearchMultipleRendererComponent',
                            cellRendererParams: (params: any) => {
                                return {
                                    defaultValue: this.smac.getCellDisplayForAssetClasses(params.data.acLevel1),
                                    noneDisplayText: params.data?.securitySymbol === '$CASH' ? 'Cash' : 'none',
                                    cellStyle: "classes",
                                    canEdit: false,
                                    hiddenLabelPanelTitle: "Schwab Asset Classes - Level 1",
                                    hiddenLabelDescription: "classes"
                                };
                            }
                        },
                        {
                            headerName: "Level 2",
                            field: "acLevel2",
                            minWidth: 80,
                            suppressFiltersToolPanel: true,
                            sortable: false,
                            floatingFilterComponent: 'irbInputFloatingFilterComponent',
                            filter: 'irbAgSearchMultipleColumnFilterComponent',
                            filterParams: (_params: any) => {
                                return {
                                    values: this.smac.getDropdownOptionsForAssetClasses(this.smac.assetClassesLevel2),
                                    enableHiddenSearchResults: false,
                                    enableEmptySearchTerm: true
                                }
                            },    
                            cellClass: 'dropdownSearchMultipleCell',
                            cellRenderer: 'DropdownSearchMultipleRendererComponent',
                            cellRendererParams: (params: any) => {
                                return {
                                    defaultValue: this.smac.getCellDisplayForAssetClasses(params.data.acLevel2),
                                    noneDisplayText: params.data?.securitySymbol === '$CASH' ? 'Cash' : 'none',
                                    cellStyle: "classes",
                                    canEdit: false,
                                    hiddenLabelPanelTitle: "Schwab Asset Classes - Level 2",
                                    hiddenLabelDescription: "classes"
                                };
                            },
                            hide: this.getDefaultHiddenState(parent, 'acLevel2', true)
                        },
                        {
                            headerName: "Level 3",
                            field: "acLevel3",
                            minWidth: 80,
                            suppressFiltersToolPanel: true,
                            sortable: false,
                            floatingFilterComponent: 'irbInputFloatingFilterComponent',
                            filter: 'irbAgSearchMultipleColumnFilterComponent',
                            filterParams: (_params: any) => {
                                return {
                                    values: this.smac.getDropdownOptionsForAssetClasses(this.smac.assetClassesLevel3),
                                    enableHiddenSearchResults: false,
                                    enableEmptySearchTerm: true
                                }
                            },    
                            cellClass: 'dropdownSearchMultipleCell',
                            cellRenderer: 'DropdownSearchMultipleRendererComponent',
                            cellRendererParams: (params: any) => {
                                return {
                                    defaultValue: this.smac.getCellDisplayForAssetClasses(params.data.acLevel3),
                                    noneDisplayText: params.data?.securitySymbol === '$CASH' ? 'Cash' : 'none',
                                    cellStyle: "classes",
                                    canEdit: false,
                                    hiddenLabelPanelTitle: "Schwab Asset Classes - Level 3",
                                    hiddenLabelDescription: "classes"
                                };
                            },
                            hide: this.getDefaultHiddenState(parent, 'acLevel3', true)
                        },  
                        {
                            headerName: "Level 4",
                            field: "acLevel4",
                            minWidth: 80,
                            suppressFiltersToolPanel: true,
                            sortable: false,
                            floatingFilterComponent: 'irbInputFloatingFilterComponent',
                            filter: 'irbAgSearchMultipleColumnFilterComponent',
                            filterParams: (_params: any) => {
                                return {
                                    values: this.smac.getDropdownOptionsForAssetClasses(this.smac.assetClassesLevel4),
                                    enableHiddenSearchResults: false,
                                    enableEmptySearchTerm: true
                                }
                            },    
                            cellClass: 'dropdownSearchMultipleCell',
                            cellRenderer: 'DropdownSearchMultipleRendererComponent',
                            cellRendererParams: (params: any) => {
                                return {
                                    defaultValue: this.smac.getCellDisplayForAssetClasses(params.data.acLevel4),
                                    noneDisplayText: params.data?.securitySymbol === '$CASH' ? 'Cash' : 'none',
                                    cellStyle: "classes",
                                    canEdit: false,
                                    hiddenLabelPanelTitle: "Schwab Asset Classes - Level 4",
                                    hiddenLabelDescription: "classes"
                                };
                            },
                             hide: this.getDefaultHiddenState(parent, 'acLevel4', true)
                        }                        
                    ]
                });
            
            cols.push({
                headerName: 'Trading Rules',
                children: [{
                    headerName: 'Min Buy $',
                    colId:'buyMinimum',
                    field: 'buyMinimum',
                    cellRenderer:'cellRendererFormatter',
                    cellRendererParams: { type: 'currency',isCashSecuritySymbol:true},
                    maxWidth: 150
                },{
                    headerName: 'Min Sell $',
                    colId:'sellMinimum',
                    field: 'sellMinimum',
                    cellRenderer: 'cellRendererFormatter',
                    cellRendererParams: { type: 'currency',isCashSecuritySymbol:true},
                    maxWidth: 150
                },{
                    headerName: 'Min Buy %',
                    colId:'buyMinimumPercent',
                    field: 'buyMinimumPercent', 
                    cellRenderer : 'cellRendererFormatter',
                    cellRendererParams: {type: 'currency', displaySymbol: '%',isCashSecuritySymbol:true, decimalPosition: '2'},
                    maxWidth: 150
                },{
                    headerName: 'Min Sell %',
                    colId:'sellMinimumPercent',
                    field: 'sellMinimumPercent', 
                    cellRenderer : 'cellRendererFormatter',
                    cellRendererParams: {type: 'currency', displaySymbol: '%',isCashSecuritySymbol:true,decimalPosition : '2'},
                    maxWidth: 150
                }]
            },{ 
                headerName:'Restrictions',
                children :[
                {
                headerName: 'Type',
                colId:'sellingTreatment',
                field: 'sellingTreatment',
                maxWidth: 180,
                minWidth: 80,
                cellClass: 'nav-link-text',
                cellRendererSelector: this.formatRestrictionsSelector,
                filter: 'agSetColumnFilter',
                filterParams: {
                    buttons:['reset', 'apply'],
                    values: (params: any) => {
                    params.success(parent.restrictionTypeList);
                    },
                    newRowsAction: 'keep',
                    suppressSorting: true,
                    cellHeight: 30,
                    closeOnApply: true,                    
                    refreshValuesOnOpen: true
                }
                },
                {
                headerName: 'Action to Take',
                colId:'conditions',
                field: 'conditions',
                maxWidth: 250,
                sortable: false, 
                cellRenderer:this.formatRestrictionCondition
            }]
            },
            { 
                headerName:'Equivalents & Alternatives',
                children:[
                {
                headerName: 'Eqvs',
                colId:'equivalenceQty',
                headerComponentParams:{
                irbColInfo: this.eqvsColInfo()
                },
                field: 'equivalenceQty',
                maxWidth: 150,
                minWidth: 80,
                cellClass: 'nav-link-text alignRight',
                cellRendererSelector: this.formatEquivalentsQtySelector,
                filter: 'agSetColumnFilter',
                filterParams: {
                    buttons:['reset', 'apply'],
                    values: (params: any) => {
                    params.success(parent.eqvSecCategoryName);
                    },
                    newRowsAction: 'keep',
                    suppressSorting: true,
                    cellHeight: 30,
                    closeOnApply: true,                    
                    refreshValuesOnOpen: true
                }

                },
                {
                headerName: 'Alt if Held',
                colId:'altIfHeldSymbol',
                headerComponentParams:{
                irbColInfo: this.altIfHeldColInfo()
                },
                field: 'altIfHeldSymbol',
                maxWidth: 150,
                cellClass: 'nav-link-text',
                    cellRendererSelector: this.formatEquivalentsAltIfHeldQtySelector
                },
                {
                headerName: 'Min Alt',
                colId:'tradeMinimumAlternativeSymb',
                field: 'tradeMinimumAlternativeSymb',
                maxWidth: 150
                },
                {
                headerName: 'Alt Sec',
                colId:'taxQualAltSecSymb',
                headerComponentParams:{
                    irbColInfo: this.altSecurityColInfo()
                },
                field: 'taxQualAltSecSymb',
                maxWidth: 150
                },
                {
                headerName: 'Alt Acct',
                colId:'invrsAccountType',
                headerComponentParams:{
                irbColInfo: this.altAccountColInfo()
                },
                field: 'invrsAccountType',
                maxWidth: 150
                },
                    {
                        headerName: 'Tax Loss Harvest',
                        colId:'isTlhEnabled',
                        field: 'isTlhEnabled',
                        maxWidth: 185,
                        minWidth: 80,
                        valueGetter: (params: any) => {
                            let returnValue = '';
                            if (params.data) {
                                switch (params.data.isTlhEnabled) {
                                    case true:
                                        returnValue = 'On';
                                        break;
                                    case false:
                                        returnValue = 'Off'
                                        break;
                                    default:
                                        returnValue = ''
                                }
                            }
                            returnValue = !parent.isTLHSetInGlobal ? '' : returnValue;
                            if (params.data && params.data.securitySymbol === "$CASH")
                              returnValue = 'n/a';
                            return returnValue;
                        },
                       filter: 'agSetColumnFilter',
                       filterParams: {
                           values: (params: any) => {
                               params.success(['On','Off']);
                           },
                           buttons: ['reset', 'apply'],
                           newRowsAction: 'keep',
                           suppressSorting: true,
                           cellHeight: 30,
                           closeOnApply: true
                       }
                    },
                    {
                        headerName: 'Wash sale alternate',
                        colId: 'tlhWashSaleSymbol',
                        field: 'tlhWashSaleSymbol',
                        maxWidth: 185,
                        minWidth: 80,
                        cellClass: (params: any) => {
                          return params.data && params.data.securitySymbol === "$CASH" ? null : 'nav-link-text';
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {
                            link: (params: any) => {
                              return params.data && params.data.securitySymbol === "$CASH" ? false : true;
                            },
                            onClick: (function (data: any) {
                                this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_SECURITY, {data: data, tlhWsaInit: true});
                            }).bind(this)
                        },
                        valueGetter: (params: any) => {
                          return params.data && params.data.securitySymbol === "$CASH" ? 'n/a' : params.data?.tlhWashSaleSymbol;
                        },
                        filter: 'agSetColumnFilter',
                         filterParams: {
                             buttons:['reset', 'apply'],
                             values: (params: any) => {
                                 params.success(parent.washSaleSymbolList);
                             },
                             newRowsAction: 'keep',
                             suppressSorting: true,
                             cellHeight: 30,
                             refreshValuesOnOpen: true,
                             closeOnApply: true
                         },
                    }]
                },
                {
                headerName:'Household Location',
                children:[
                {
                headerName: 'Level',
                colId:'taxabilityBias',
                headerComponentParams:{
                irbColInfo: this.levelColInfo()
                },
                field: 'taxabilityBias', 
                cellRenderer : 'cellRendererFormatter',
                cellRendererParams: {type: 'currency', displaySymbol: ' '},
                maxWidth: 150
                },
                {
                headerName: 'Roth Level',
                colId:'rothLevel',
                headerComponentParams:{
                irbColInfo: this.rothColInfo()
                },
                field: 'rothLevel',
                cellRenderer : 'cellRendererFormatter',
                cellRendererParams: {type: 'currency', displaySymbol: ' '},
                    maxWidth: 150
                }]
                },
                {
                headerName:'Redemption Penalties',
                children:[
                {
                    headerName: 'Amount $',
                    colId:'redemptionPenaltyDollarAmount',
                    field: 'redemptionPenaltyDollarAmount', 
                    cellRenderer : 'cellRendererFormatter',
                    cellRendererParams: {type: 'currency', displaySymbol: '$'},
                    maxWidth: 150
                },
                {
                headerName: 'Days $',
                colId:'tdaRedemptionPenaltyDays',
                field: 'tdaRedemptionPenaltyDays', 
                cellRenderer : 'cellRendererFormatter',
                cellRendererParams: {type: 'currency', displaySymbol: ' '},
                    maxWidth: 150
                },
                {
                headerName: 'Amount %',
                colId:'redemptionPenaltyPercent',
                field: 'redemptionPenaltyPercent', 
                cellRenderer : 'cellRendererFormatter',
                cellRendererParams: {type: 'currency', displaySymbol: '%',decimalPosition : '2'},
                    maxWidth: 150
                },
            {
                headerName: 'Days %',
                colId:'redemptionPenaltyDays',
                field: 'redemptionPenaltyDays', 
                cellRenderer : 'cellRendererFormatter',
                cellRendererParams: {type: 'currency', displaySymbol: ' '},
                maxWidth: 150
                },
                
            ]
            },
            { 
                headerName:'External Holdings',
                children:[{
                headerName: 'Share Price',
                colId:'externalSharePrice',
                field: 'externalSharePrice',
                headerComponentParams:{
                irbColInfo: this.extHoldingsSharePriceColInfo()
                },
                cellRendererSelector:this.formatSharePrice,
                    maxWidth: 150
            }]
            },
            { 
                headerName:'Options',
                children:[{
                headerName: 'Options',
                colId:'hasOptions',
                headerComponentParams:{
                irbColInfo: this.optionColInfo()
                },
                field: 'hasOptions',
                    maxWidth: 150,
                cellRendererSelector:this.formatHasOptions,
            }]
            }
        );
        if (parent.ENABLE_AS_SECTYPE) {
            cols[1].children.splice(4, 0, {
                headerName: 'Security Type',
                colId: 'sacSecurityType',
                field: 'sacSecurityType',
                maxWidth: 220,
                minWidth: 80,
                filter: 'irbAgSearchMultipleColumnFilterComponent',
                suppressFiltersToolPanel: true,
                floatingFilterComponent: 'irbInputFloatingFilterComponent',
                filterParams: (_params: any) => {
                    return {
                        values: this.ssts.getDropdownOptionsForSacSecurityTypes(),
                        enableHiddenSearchResults: false,
                        enableEmptySearchTerm: true
                    };
                }
            });

            cols[1].children.splice(8, 0, {
                headerName: "Morningstar Stock Style",
                field: 'styleBoxLabel',
                suppressFiltersToolPanel: true,
                floatingFilterComponent: 'irbInputFloatingFilterComponent',
                filter: 'irbAgSearchMultipleColumnFilterComponent',
                filterParams: (_params: any) => {
                    return {
                        values: this.mss.getDropdownOptionsForMorningstarStyles(),
                        enableHiddenSearchResults: false,
                        enableEmptySearchTerm: true
                    }
                },
                maxWidth: 250,
                minWidth: 80
            });
        }

        if (parent.roles.MMC_ADMIN) {
            cols[1].children.splice(3, 1);
        }

        if (!parent.isTlhWsaEnabled) {
            cols[4].children.splice(5, 2);
        }

        return cols;
    }

    customCategoryColInfo(){
        return `
        <div class="block">You can create your own categories for securities – by asset class, industry, or
         however you prefer to identify and organize your security types. When Morningstar mapping 
         for ETFs and mutual funds is enabled in the global settings, items marked with a * are the
          matching Morningstar category for that ETF or mutual fund.</div>
          <div>Schwab and Morningstar are not affiliated.</div>
        `}
    
      levelColInfo(){
          return `
          <p>The asset location level is a number assigned to each security that represents your relative preference for each security to be purchased in either a qualified account or a taxable account. +100 represents the highest tax impact, and therefore the greatest preference for qualified account placement, while -100 represents the lowest tax impact, and therefore the greatest preference for taxable account placement.</p>
          <p>During rebalancing, iRebal will identify securities with the highest absolute value of location level and will attempt to place those securities into the desired accounts first. Securities marked closer to -100 and +100 will have a greater likelihood of being placed into the appropriate taxable and qualified accounts. Note: When locating into a qualified account, level does not make a distinction between qualified and Roth accounts.</p>
          <p>If a security is already held in the portfolio and you prefer that subsequent purchases of the security are placed in the account where it is already held, enter a location level of between -49 to +49 for the security.</p>
          ` }
    
      rothColInfo(){
        return `<p>The Roth level is a number assigned to securities identifying a preference to be bought in a Roth account. Numbers may range from +100 to 0, with +100 representing greatest preference to locate into a Roth account relative to other securities with a lower Roth level.</p>
        <p>During rebalancing, securities with a defined Roth level have the highest priority of placement, and will be located first based on the securities with the highest Roth level value. In absence of a defined Roth level, iRebal will locate securities based on location level, and will not make a distinction between qualified and Roth accounts.</p>
        `
        }
    
      altSecurityColInfo(){
      return `<p>These settings tell iRebal to purchase an alternate security which will be used in place of this security when trading in a certain account type. For example, if the subject security is a corporate bond fund, and you'd like to use a municipal bond fund in its place in taxable accounts, enter the symbol for the municipal bond fund in the Alt Sec field and select Taxable as the Alt Acct.</p>`
      }
    
      altAccountColInfo(){
        return `<p>These settings tell iRebal to purchase an alternate security which will be used in place of this security when trading in a certain account type. For example, if the subject security is a corporate bond fund, and you'd like to use a municipal bond fund in its place in taxable accounts, enter the symbol for the municipal bond fund in the Alt Sec field and select Taxable as the Alt Acct.</p>`
        }
    
      eqvsColInfo(){
       return `<p>Equivalents are securities, that when held, will be considered "equivalent" to this security when calculating a portfolio's allocations. Equivalent securities will not be purchased in place of each other, but can be sold.</p>`
      }
    
      altIfHeldColInfo(){
       return `<p>Alt if Held securities are those you'd like iRebal to purchase instead of a specific security when the Alt if Held is already in the account. If you specify multiple alternates, iRebal will purchase whichever one there's more of in the account.</p>
            <p>Example: An alternate might be specified in the case of a fund that's closed to new investors: Since subsequent future purchases of the closed fund are sometimes allowed, the Alt if Held fund will be purchased when the fund is held; the new fund will only be purchased for initial investors.</p>`
      }
      nerColInfo(){
        return `<p>NER is the estimated net expense ratio or, the estimated cost investors are charged from fund assets to be invested in the security.</p>`
      }
      optionColInfo(){
        return `<p>These are options iRebal identified your clients hold or have been added to the security master.</p>`
      }
           
    
      cashSecurity(){
        return `<p>$CASH is a security in the iRebal security master representing cash. All liquid cash and account sweeps held in accounts will be mapped to $CASH. Sweep money market securities cannot be added to iRebal. Any trading rules (like minimums and location preference) cannot be used on the $CASH securities.</p>
        <p>You can add $CASH as a model allocation in any model and you can also edit the asset category for $CASH. </p>`
      }
    
      extHoldingsSharePriceColInfo(){
        return `<p>You must enter the share price for any securities not in the Charles Schwab & Company, Inc. ("Schwab") security master. If a share price is not entered for an externally held security, iRebal will assume a price of $1. For any securities that are in the Schwab database, iRebal will calculate the position's value based on the shares you have listed here and the current market price.</p>`
      }
      
    formatSecurityTypeSelector = (params:any) => {
            if (params.data) {
                return {
                    component: 'cellRendererFormatter',
                    params: {
                        value: this.formatSecurityType(params)
                    }
                };
            }
    }
   
    formatHasOptions = (params:any) => {
         if (params.data) {
           if (params.data.hasOptions === true && params.data.optionsCount) {
             return {
               component: 'cellRendererFormatter',
               params: {value: params.data.optionsCount.toString(),
                 link: (params: any) => {
                   return (params.value != null && params.value.length > 0);
                 },
                 onClick: (function (data: any) {
                   this.as.fireEvent(IrbModelsEvents.SHOW_VIEW_SECURITY_MODEL, { data: data});
                 }).bind(this)
               }
             };
           } else if (params.data.hasOptions === true) {
               return {
                 component: 'cellRendererFormatter',
                 params:{value:'View',
                   link: (params: any) => {
                     return (params.value != null && params.value.length > 0);
                 },
                 onClick: (function (data: any) {
                              this.as.fireEvent(IrbModelsEvents.SHOW_VIEW_SECURITY_MODEL, { data: data});
                     }).bind(this)
             }
           }
         }else if(params.data.hasOptions === false){
           return{
             component: 'cellRendererFormatter',
                 params:{value:'n/a',
           } 
         }
       }
      }
     
    }
   
   formatRestrictionCondition(params:any){      
        if(params.data?.sellingTreatment === 'NEVER_BUY' || params.data?.sellingTreatment === 'NEVER_BUY_AND_SELL'){
            switch(params.data.conditions){
                case "Leave in cash": return "Leave in Cash";
                case "Buy an alternate security": return params.data.altSecuritySymbol;
                case "Pro-rate across other model securities": return "Pro-rate";
                default : return  ""; 
            }
        }
   }

   formatRestriction = (params:any)=> {
        switch(params.data?.sellingTreatment){
            case "NEVER_SELL": return "Never Sell";
            case "NO_RESTRICTION": return "No restriction";
            case "NEVER_BUY": return "Never Buy";
            case "NEVER_BUY_AND_SELL": return "Never Buy and Never Sell";
            case "UN_MANAGED": return "Exclude";
            default : return  "";
        }
    }

  formatRestrictionsSelector = (params:any) => {
      if (params.data) {
          return {
              component: 'cellRendererFormatter',
              params:{value:this.formatRestriction(params),
                  link: (params: any) => {
                      return (params.value != null && params.value.length > 0);
                  },
                  onClick: (function (data: any) {
                      this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_SECURITY, { data: data, restrictionsInit: true });
                  }).bind(this)
              }
          };
      }
  }

  formatEquivalentsQtySelector = (params:any) => {
      if (params.data) {
          return {
              component: 'cellRendererFormatter',
              params:{
                  link: () => {
                      return true;
                  },

                  onClick: (function (data: any) {
                      this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_SECURITY, { data: data, equivalentsInit: true });
                  }).bind(this)
              }
          };
      }
  }

  formatEquivalentsAltIfHeldQtySelector = (params:any) => {
      if (params.data) {
          return {
              component: 'cellRendererFormatter',
              params:{
                  link: () => {
                      return true;
                  },

                  onClick: (function (data: any) {
                      this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_SECURITY, { data: data, equivalentsInit: true });
                  }).bind(this)
              }
          };
      }
  }

  formatSecurityType = (params:any) => {
      switch (params.data?.securityType) {
          case "EQUITY":
              return "Equity";
          case "EQ":
              return "Equity";
          case "MUTUAL_FUND":
              return "Mutual Fund";
          case "MF":
              return "Mutual Fund";
          case "CASH":
              return "Cash";
          case "GROUP":
              return "Group";
          case "BOND":
              return "Bond";
          case "OTHER":
              return "Other";
          case "EXTERNAL":
              return "External";
          case "CustCat":
              return "Category";
          case "OPTION":
              return "Option";
          default:
              return params.data?.securityType;
      }
  }

  formatSharePrice(params:any){
    if (params.data) {
        if (params.data?.securitySymbol === '$CASH' || params.data?.securityType !== 'EXTERNAL') {
           return {              
              component: 'cellRendererFormatter',  
              params:{'value':'n/a'}     
             }
        } else if (params.data?.securityType === 'EXTERNAL'){
  
          if (params.data.externalSharePrice) {
              return {
                  component: 'cellRendererFormatter',
                  params: {'value': params.data.externalSharePrice, 'type': 'currency', 'decimalPosition': '2'}
              }
          }else {
              return {
                  component: 'cellRendererFormatter',
                  params:{'value':'--'}
              }
          }
        }
      }
    }

    getDefaultHiddenState(parent: SecurityMasterComponent, fieldName: string, defaultState: boolean) {
        let s: any = JSON.parse(window.localStorage.getItem(parent.componentName) || "{}");

        if(s.COL_STATE) {
            let c: any  = JSON.parse(s.COL_STATE);

            if(c) {
                let d = c.find((x: any) => x.colId === fieldName);
                return d?.hide;
            }
        }

        return defaultState;
    }

    getColumnLimits() {
        return {
            columnLimits: [
                { key: 'securitySymbol', minWidth: 95 },
                { key: 'securityDescription', minWidth: 150 },
                { key: 'securityType', minWidth: 97 },
                { key: 'sacSecurityType', minWidth: 108 },
                { key: 'securityModels', minWidth: 122 },
                { key: 'customCategoryName', minWidth: 137 },
                { key: 'netExpenseRatio', minWidth: 85 },
                { key: 'styleBoxLabel', minWidth: 112 },
                { key: "acLevel1", minWidth: 120 },
                { key: "acLevel2", minWidth: 120 },
                { key: "acLevel3", minWidth: 120 },
                { key: "acLevel4", minWidth: 120 },
                { key: 'buyMinimum', minWidth: 90 },
                { key: 'sellMinimum', minWidth: 90 },
                { key: 'buyMinimumPercent', minWidth: 90 },
                { key: 'sellMinimumPercent', minWidth: 90 },
                { key: 'sellingTreatment', minWidth: 105 },
                { key: 'conditions', minWidth: 116 },
                { key: 'equivalenceQty', minWidth: 85 },
                { key: 'altIfHeldSymbol', minWidth: 106 },
                { key: 'tradeMinimumAlternativeSymb', minWidth: 74 },
                { key: 'taxQualAltSecSymb', minWidth: 83 },
                { key: 'invrsAccountType', minWidth: 92 },
                { key: 'isTlhEnabled', minWidth: 130 },
                { key: 'tlhWashSaleSymbol', minWidth: 146 },
                { key: 'taxabilityBias', minWidth: 78 },
                { key: 'rothLevel', minWidth: 105 },
                { key: 'redemptionPenaltyDollarAmount', minWidth: 92 },
                { key: 'tdaRedemptionPenaltyDays', minWidth: 80 },
                { key: 'redemptionPenaltyPercent', minWidth: 87 },
                { key: 'redemptionPenaltyDays', minWidth: 85 },
                { key: 'externalSharePrice', minWidth: 111 },
                { key: 'hasOptions', minWidth: 96 },
                { key: 'createdDate', minWidth: 170 }
            ]
        }
    }
}
